import { Api, ModelRow, Navigation, RowUpdateEvent, StringUtil, UrlUtil } from "@mcleod/core";
import { AutogenLayoutSendInfoPacket } from "./autogen/AutogenLayoutSendInfoPacket";
import { Button, ClickEvent, DataDisplayEvent, Label, Layout, Slideout, SlideoutDecorator, Snackbar, TableRow, TableRowDisplayEvent, Toast } from "@mcleod/components";

export class SendInfoPacket extends AutogenLayoutSendInfoPacket {

    private _prospectActionId: string;
    private _infoPacketId: string;
    private validFiles: string[] = [];

    labelFilenameOnDataDisplay(event: DataDisplayEvent): void {
        const filename = event.rowData?.getString("filename", null);
        const labelFileName = event.target as Label;
        labelFileName.text = filename ? filename.substring(filename.lastIndexOf("\\") + 1) : "";
    }

    buttonPreviewOnClick(event: ClickEvent): void {
        const button = event.target as Button;
        const tableRow = TableRow.getContainingTableRow(button);
        const modelRow = tableRow.data;
        Navigation.navigateTo("lme/crm/InfoPacketPreview?"+ UrlUtil.buildQueryString({ key: modelRow.getString("id") }), {
            width: window.screen.availWidth,
            height: window.screen.availHeight,
            newTab: true,
            windowDecorators: false
        });
    }

    tableAttachmentsOnRowDisplay(event: TableRowDisplayEvent): void {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const fileName = modelRow.getString("filename", null);
        const validFile = this.validFiles.includes(fileName);
        const imageError = tableRow.findComponentById("imageError");
        if (imageError) {
            imageError.visible = !validFile;
        }
        const buttonPreview = tableRow.findComponentById("buttonPreview");
        if (buttonPreview) {
            buttonPreview.enabled = validFile;
        }
    }

    static checkInfoPacket(prospectAction: ModelRow): Promise<any> { 
        if (!prospectAction.isNull("info_packet_id")
        && !prospectAction.isNull("action_date")
        && "C" === prospectAction.get("status", null)) {
            this.showSlideout(prospectAction.getString("id"), prospectAction.getString("info_packet_id"));
        }
        return Promise.resolve();
    }

    static showSlideout(prospectActionId: string, infoPacketId: string) {
        const sendInfoPacket = Layout.getLayout("lme/crm/SendInfoPacket") as SendInfoPacket;
        sendInfoPacket.addLayoutLoadListener(() => {
            sendInfoPacket.prospectActionId = prospectActionId;
            sendInfoPacket.infoPacketId = infoPacketId;
        });
        const buttonSend = new Button({
            caption: "Send",
            color: "default.reverse",
            backgroundColor: "primary",
            width: 120,
            rowBreak: false,
            borderWidth: 0
        });
        const decorator = new SlideoutDecorator({
            layout: sendInfoPacket,
            title: "Send Info Packet",
            addlComponents: [buttonSend],
            width: 1200, 
            height: window.innerHeight, 
            backgroundColor: "white", 
            padding: 0
        })
        buttonSend.addClickListener(() => {
            decorator.slideOut();
            Api.post("lme/crm/send-info-packet", {
                prospect_action_id: prospectActionId,
                info_packet_id: infoPacketId,
                email: sendInfoPacket.textboxEmail.text,
                cc: sendInfoPacket.textboxCC.text,
                subject: sendInfoPacket.textboxSubject.text,
                body: sendInfoPacket.textboxComment.text
            }).then(() => Toast.showSuccessToast("Information Packet Sent"));
        });
    }

    public set prospectActionId(value: string) {
        this._prospectActionId = value;
        this.sourceProspectAction.search({ "id": this._prospectActionId });
    }

    public set infoPacketId(value: string) {
        this._infoPacketId = value;
        this.sourceInfoPacketHeader.search({ "id": this._infoPacketId, "include_attachments": true })
        .then(() => {
            const attachments = this.sourceInfoPacketHeader.activeRow?.getString("attachments", null);
            this.validFiles = attachments ? attachments.split(",").filter(s => !StringUtil.isEmptyString(s)) : [];
        });
    }
}